import { render, staticRenderFns } from "./event-radio.vue?vue&type=template&id=ae1ca20e&scoped=true&"
import script from "./event-radio.vue?vue&type=script&lang=js&"
export * from "./event-radio.vue?vue&type=script&lang=js&"
import style0 from "./event-radio.vue?vue&type=style&index=0&id=ae1ca20e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1ca20e",
  null
  
)

export default component.exports